<template>
  <div class="container-fluid">
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">{{ $t("PROPERTIES.SHIPPING_SAVED_LETTERS") }}</h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openShipmentEstimationCreateModal"
              v-if="$currentUserCan($permissions.PERM_SHIPPING_LETTERS_PROPERTIES)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">{{
                $t("SHIPMENTS.CREATE_NEW_ESTIMATION")
              }}</span>
            </base-button>
            <notification-subscription
              v-if="$currentUserCan($permissions.PERM_SHIPPING_LETTERS_PROPERTIES)"
              :objectType="'shipmentEstimation'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />
          </div>
        </div>
      </div>

      <shipment-estimation-list-table
        @onViewShipmentEstimation="openShipmentEstimationViewModal"
        @onApproveShipmentEstimation="approveShipmentEstimation"
        @onCancelShipmentEstimation="cancelShipmentEstimation"
        @onCancelPickup="cancelPickup"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewShipmentEstimationModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewShipmentEstimationModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'BLACK_LIST_USER_VIEW'"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SHIPMENTS.VIEW_SHIPMENT_ESTIMATION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <!--<notification-subscription
                v-if="openShipmentEstimation"
                :objectType="'sipmentEstimations'"
                :objectId="openShipmentEstimation.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button class="edit" @click="approveShipmentEstimation(openShipmentEstimation)" v-if="openShipmentEstimation.status=='PENDING'">
                  <i class="fal fa-check"></i>
                  <span>{{ $t("SHIPMENTS.APPROVE") }}</span>
                </button>
              </base-dropdown>-->
              <button class="close" @click="closeShipmentEstimationModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-shipment-estimation-page 
            v-if="openShipmentEstimation" 
            :isOpenPickupForm="isOpenPickupForm"  
            :shipmentEstimationId="openShipmentEstimation.id"
            @onPickupSubmitted="pickupCreated"
            @onCancelEstimation="cancelShipmentEstimation" />
          </div>
        </div>
      </div>

      <div
        v-if="isCreateEstimationModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isCreateEstimationModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div class="resizable-wrapper-content" v-resizable-modal="'SHIPMENT'">
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SHIPMENTS.CREATE_NEW_ESTIMATION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="closeCreateShipmentEstimationModal">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-shipment-estimation-page
              :onlyConfirmed="onlyConfirmed"
              :displayPrintButtons="displayPrintButtons"
              :propertyStatus="propertyStatus"
              @onViewShipmentEstimation="openShipmentEstimationViewModal"
              @onShipmentEstimationCreated="closeCreateShipmentEstimationModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ShipmentEstimationListTable from "./partials/ShipmentEstimationListTable.vue";
import AddShipmentEstimationPage from "./components/AddShipmentEstimationComponent.vue";
import ViewShipmentEstimationPage from "./components/ViewShipmentEstimationComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ShipmentEstimationListTable,
    NotificationSubscription,
    AddShipmentEstimationPage,
    ViewShipmentEstimationPage,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  created(){
    console.log('shipment estimation Page');
  },

  watch: {},

  data() {
    const shipmentEstimationId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewShipmentEstimationModalOpened = false;
    let isCreateEstimationModalOpened = false;
    let openShipmentEstimation = null;
    if (shipmentEstimationId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewShipmentEstimationModalOpened = true;
      }
      openShipmentEstimation = { id: shipmentEstimationId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isCreateEstimationModalOpened = true;
    }
    return {
      isViewShipmentEstimationModalOpened: isViewShipmentEstimationModalOpened,
      isCreateEstimationModalOpened: isCreateEstimationModalOpened,
      openShipmentEstimation: openShipmentEstimation,
      renderKey: 1,
      propertyStatus: 'CONFIRMED',
      onlyConfirmed: true,
      displayPrintButtons: true,
      isOpenPickupForm: false,
    };
  },

  methods: {
    openShipmentEstimationCreateModal() {
      this.closeShipmentEstimationModal();
      this.isCreateEstimationModalOpened = true;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List ShipmentEstimations",
          query: { action: QUERY_ACTIONS_ADD },
        }).href
      );
    },
    openShipmentEstimationViewModal(shipmentEstimation, reRender = false) {
      this.closeShipmentEstimationModal();
      this.openShipmentEstimation = shipmentEstimation;
      this.isViewShipmentEstimationModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List ShipmentEstimations",
          query: { id: this.openShipmentEstimation.id, action: QUERY_ACTIONS_VIEW },
        }).href
      );
    },
    async approveShipmentEstimation(estimation) {
      const confirmation = await swal.fire({
        title: this.$t("SHIPMENTS.APPROVE_THIS_ESTIMATION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        this.$store.dispatch("properties/createShippingSavedLetters", {group_id: estimation.id});
        swal.close();
        this.$notify({
          type: "success",
          message: this.$t("SHIPMENTS.SHIPMENT_TO_CREATE"),
        });
        /*if (confirmation.value === true) {
            swal.fire({
              allowEscapeKey: false,
              allowOutsideClick: false,
              onOpen: () => {
                swal.showLoading();
              },
            });
            const response = await this.$store.dispatch("properties/createShippingSavedLetters", {estimations : estimation.shippments, group_id: estimation.id});
            //this.getList('PENDING');
            this.renderKey++;
            swal.close();
            this.$notify({
                type: "success",
                message: this.$t("PROPERTIES.SHIPPMENT_CREATED"),
            });
        }*/
      } catch (error) {
        await this.showRequestError(error);
        swal.close();
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.  $t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    async cancelShipmentEstimation(estimation) {
      const confirmation = await swal.fire({
        title: this.$t("SHIPMENTS.CANCEL_THIS_ESTIMATION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        this.$store.dispatch("properties/cancelShippingSavedLetters", {group_id: estimation.id});
        swal.close();
        this.$notify({
          type: "success",
          message: this.$t("SHIPMENTS.SHIPMENT_TO_CANCEL"),
        });
        /*if (confirmation.value === true) {
            swal.fire({
              allowEscapeKey: false,
              allowOutsideClick: false,
              onOpen: () => {
                swal.showLoading();
              },
            });
            const response = await this.$store.dispatch("properties/cancelShippingSavedLetters", {estimations : estimation.shippments, group_id: estimation.id});
            //this.getList('PENDING');
            this.renderKey++;
            swal.close();
            this.$notify({
                type: "success",
                message: this.$t("PROPERTIES.SHIPPMENT_CANCELED"),
            });
        }*/
      } catch (error) {
        await this.showRequestError(error);
        swal.close();
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.  $t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    async cancelPickup(estimation){
      const confirmation = await swal.fire({
        title: this.$t("SHIPMENTS.CANCEL_THIS_PICKUP"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        this.$store.dispatch("properties/cancelPickup", {group_id: estimation.id});
        swal.close();
        this.$notify({
          type: "success",
          message: this.$t("SHIPMENTS.PICKUP_TO_CANCEL"),
        });
        /*if (confirmation.value === true) {
          swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            onOpen: () => {
              swal.showLoading();
            },
          });
            const response = await this.$store.dispatch("properties/cancelPickup", {group_id: estimation.id});
            //this.getList('PENDING');
            this.renderKey++;
            swal.close();
            this.$notify({
                type: "success",
                message: this.$t("SHIPMENTS.PICKUP_CANCELED"),
            });
        }*/
      } catch (error) {
        await this.showRequestError(error);
        swal.close();
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.  $t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    openPickupForm(){
      this.isOpenPickupForm = true;
    },
    pickupCreated(){
      this.renderKey++;
    },
    shipmentEstimationCreated(){
      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List ShipmentEstimations",
          query: {},
        }).href
      );
    },
    closeShipmentEstimationModal() {
      this.isCreateEstimationModalOpened = false;
      this.isViewShipmentEstimationModalOpened = false;
      this.openShipmentEstimation = null;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List ShipmentEstimations",
          query: {},
        }).href
      );
    },
    closeCreateShipmentEstimationModal() {
      this.isCreateEstimationModalOpened = false;
      this.isViewShipmentEstimationModalOpened = false;
      this.openShipmentEstimation = null;

      history.pushState(
        {},
        null,
        this.$router.resolve({
          name: "List ShipmentEstimations",
          query: {},
        }).href
      );
    },
  },
};
</script>
